import { Component, Input, OnChanges } from '@angular/core';

import { Data2Service } from '../../common/data2.service';
import { BankCard, BankCardsHistory } from '../bank.model';

@Component({
	selector: 'app-bank-card-transactions',
	templateUrl: './bank-card-transactions.component.html',
	styleUrls: ['./bank-card-transactions.component.css'],
})
export class BankCardTransactionsComponent implements OnChanges {
	@Input() card: BankCard;
	data: BankCardsHistory[] = [];

	constructor(private readonly api: Data2Service) {}

	ngOnChanges(): void {
		if (!this.card) {
			return;
		}
		this.loadData();
	}

	private loadData(): void {
		this.api.get(`/bankCardsHistory/?card=${this.card.id}`, (result, error) => {
			this.data = result.data;
		});
	}
}
